﻿
$.fn.dxCtrlSelectBoxCompteEmail = function custom_dxCtrlSelectBoxCompteEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlselectboxcompteemail dx-ctrl");
        this.createInstance(new cdxCtrlSelectBoxCompteEmail(this, option));
    }
    return this;
}

window.cdxCtrlSelectBoxCompteEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
        var lstEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail()
        if (typeof option.value == 'undefined') {
            option.value = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetDataCompteEmailDefaut()
        }
        $("<div/>").appendTo(container).dxCtrlSelectBox({
            labelMode: 'floating',
            label: "Expéditeur",
            readOnly: option.readOnly,
            dataSource: lstEmail,
            value: option.value,
            displayExpr: "adresse_email",
            itemTemplate: function (itemData, itemIndex, itemElement) {
                option.bddCtrl.getObjet(itemData).objetMetier.templateTitleEmail(itemElement, option.bddCtrl.utiCourant.id_utilisateur)
            },
            onValueChanged: function (e) {
                option.value = e.value
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(e)
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}